export default {
  methods:{
    backPage (){
      this.$router.go(-1);
    }
  }

}



// WEBPACK FOOTER //
// ./src/mixin/back.js